import { getters } from './getters';
import { actions } from './actions';
import { mutations } from './mutations';

const state = {
  meta: { count: 0, currentPage: 1 },
  records: {},
  sortOrder: [],
  currentList: null,
  memberMeta: { count: 0, currentPage: 1 },
  memberRecords: {},
  memberSortOrder: [],
  uiFlags: {
    isFetching: false,
    isFetchingItem: false,
    isCreating: false,
    isUpdating: false,
    isDeleting: false,
    isDuplicating: false,
    isFetchingMembers: false,
    isAddingMember: false,
    isRemovingMember: false,
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
